import { render } from "./ShopAlipayDMF.vue?vue&type=template&id=5e38993b&scoped=true"
import script from "./ShopAlipayDMF.vue?vue&type=script&lang=js"
export * from "./ShopAlipayDMF.vue?vue&type=script&lang=js"

import "./ShopAlipayDMF.vue?vue&type=style&index=0&id=5e38993b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e38993b"]])

export default __exports__